import React from 'react'

import type { UploadIdentityType } from '../upload/types'
import { FileNameToolTip } from './FileNameToolTip'
import {
  BackToTheFront,
  CenterButtons,
  Content,
  FileListItem,
  IconButton,
  List,
  MessageBodyCenter,
  MessageBodyCenterBold,
  MessageBodyCenterSmall,
  MessageBodyListBody,
  MessageBodyListHeaderBold,
  MessageBold,
  MessageListBodyCenterBold
} from './styled-components'
import type { FileStatus, UIConfigType } from './types'

type SuccessPageProps = {
  uiConfig: UIConfigType
  claimNumber: string
  successes: FileStatus[]
  textColor: string
  successSvgColor: string
  successHref: string
  trackingError: boolean
  identity: UploadIdentityType
  onBackToUploadPage(): (event: React.SyntheticEvent) => void
  onFindClaimClick(event: React.SyntheticEvent): void
}

const SuccessPage = (props: SuccessPageProps) => {
  const {
    uiConfig,
    claimNumber,
    successes,
    textColor,
    successSvgColor,
    successHref,
    trackingError,
    identity,
    onBackToUploadPage,
    onFindClaimClick
  } = props

  return (
    <Content>
      {uiConfig.icon}
      <MessageBodyCenter>
        {uiConfig.info.pre}
        <MessageBold>
          {claimNumber.toUpperCase()}
        </MessageBold>
        {uiConfig.info.post}
      </MessageBodyCenter>
      <MessageBodyCenterSmall>
        Please note: larger files may take longer to process.
      </MessageBodyCenterSmall>
      {
        <List color={textColor} background="#FFFFFF">
          <MessageListBodyCenterBold>Files for upload</MessageListBodyCenterBold>
          <MessageBodyListHeaderBold> FILES UPLOADED </MessageBodyListHeaderBold>
          <MessageBodyListBody>
            <FileListItem id="success-list">
              {successes.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={successHref}
                  svgColor={successSvgColor}
                />
              )}
            </FileListItem>
          </MessageBodyListBody>
        </List>
      }
      {!trackingError &&
        <MessageBodyCenterBold>{uiConfig.nextSteps}</MessageBodyCenterBold>
      }
      {!trackingError &&
        <MessageBodyCenter>
          {uiConfig.nextStepsCopy?.pre}{identity.email + '.'} {uiConfig.nextStepsCopy?.post}
        </MessageBodyCenter>
      }
      <br></br>
      <MessageBodyCenter>Submit more files for <MessageBold>
        {claimNumber.toUpperCase()}
      </MessageBold> or start a new upload.</MessageBodyCenter>
      <CenterButtons>
        <IconButton onClick={onBackToUploadPage()}>
          {uiConfig.backButtonText}
        </IconButton>
        <BackToTheFront onClick={onFindClaimClick} href="#">NEW UPLOAD</BackToTheFront>
      </CenterButtons>
    </Content>
  )
}

export { SuccessPage }
